import React, { Component } from 'react';
import { connect } from 'react-redux';
import WebSocketConnection from '../WebSocketConnection';
import ChatPanel from '../ChatPanel/index';
import '../../index.css';
import IsMobileContext from '../../context/IsMobileContext';
import OpenStateListener from '../OpenStateListener';
import { updateScroll } from '../MessageHistory';
import { updateDocumentVisibility } from '../../reducers/ui/actions';

class WebChat extends Component {
  state = {
    isMobile: window.webChatConfig.isMobile
  };

  onVisibilityChange = () => {
    const { updateDocumentVisibility } = this.props;
    const visible = document.visibilityState === 'visible';
    updateDocumentVisibility(visible);
  };

  componentWillMount() {
    window.addEventListener('message', e => {
      if (e.data.type === 'updateIsMobile' && this.state.isMobile !== e.data.isMobile) {
        this.setState({ isMobile: e.data.isMobile });
      } else if (e.data.type === 'scrollToBottom') {
        updateScroll(true);
      }
    });

    window.parent.postMessage(
      {
        source: 'ambitChatPanel',
        type: 'webchatReactLoaded'
      },
      '*'
    );

    // Set the initial visibility
    this.onVisibilityChange();

    // Update state whenever the tab/window changes focus
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  render() {
    return (
      <IsMobileContext.Provider value={this.state.isMobile}>
        <OpenStateListener />
        <WebSocketConnection />
        <ChatPanel />
      </IsMobileContext.Provider>
    );
  }
}

const mapDispatchToProps = {
  updateDocumentVisibility
};

export default connect(null, mapDispatchToProps)(WebChat);



// WEBPACK FOOTER //
// ./src/components/WebChat/index.js